module.exports = __webpack_public_path__ + "media/images/icon/chevron-down-black-f5e5ddf586402fdc2018fc80cfd86e81.svg";